import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import Employee from '@/repositories/data/employees/Employee';

export default class EmployeeRepository extends BaseCrudRepository<number, Employee, Employee> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/employee/');
    }

    protected processBeforeCreate(user: Employee): Employee {
        user.order = -1;
        return user;
    }
}
